import { Checkbox } from '@digitools/honest-ui';
import React from 'react';
import useTranslate from 'src/hooks/useTranslate';
import { ReviewAccommodationDetailsText } from '../../constants/ReviewAccommodationDetailsText';
import useAsDataContext from '../../hooks/useAsDataContext';
// Must render inside an honest-ui <Form>; Review.tsx provides it
const DisclaimerContent = () => {
    const { isDisclaimerAccepted, setIsDisclaimerAccepted } = useAsDataContext();
    const { t } = useTranslate();
    return (<div className='hui-mb-xl' data-testid='disclaimer-text'>
      <Checkbox name='acknowledgement' data-testid='acknowledgement' defaultChecked={isDisclaimerAccepted} 
    // Context still drives the submit button's disabled state, as before
    onChange={e => setIsDisclaimerAccepted(e.currentTarget.checked)} label={<>
            {t(ReviewAccommodationDetailsText.disclaimerText)}
            <sup>1</sup>
          </>}/>
    </div>);
};
export default React.memo(DisclaimerContent);
